// extracted by mini-css-extract-plugin
export default {"trustBadge":"TrustBadge_trustBadge__1PE1i"};